<template>
  <div>
    <div class="operations" style="width: 280px;margin-top: 5px;margin-left:5px">
      <el-button :disabled="isEdit" no="openInsure" type="primary" @click="openInsure">{{ $t('SeaExport.Insure') }}</el-button>
    </div>
    <div style="display: flex;flex-grow:1">
      <div class="section" style="width:220px;flex: none">
        <cargo-ag-grid
          :show-side-bar="false"
          :grid-options="left.gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="leftColumnDefs"
          :row-data="left.rowData"
          style="width:100%;height:100%"
          @gridReady="params=>{left.gridApi=params.api}"
        />
      </div>
      <div class="section" style="margin-left:10px;flex: 1">
        <cargo-ag-grid
          config-module="1300012"
          :grid-options="right.gridOptions"
          :grid-params.sync="gridParams"
          :column-defs="rightColumnDefs"
          :row-data="right.rowData"
          style="width:100%;height:100%"
          @gridReady="params=>{right.gridApi=params.api}"
        />
      </div>
    </div>
    <!-- 预览文件弹窗 -->
    <cargo-dialog
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :can-maximize="true"
      custom-class="preview-dialog"
      @close="closePreviewDialog"
    >
      <div>
        <!--        <el-scrollbar>-->
        <!--          <pdf v-for="i in previewFileData.numPages" :key="i" :src="previewFileData.pdfSrc" :page="i" />-->
        <!--        </el-scrollbar>-->
        <p style="text-align: center">
          <span class="turn" :class="{grey: previewFileData.currentPage==1}" @click="changePdfPage(0)">{{ $t('SeaExport.Pre') }}</span>
          {{ previewFileData.currentPage }} / {{ previewFileData.numPages }}
          <span class="turn" :class="{grey: previewFileData.currentPage==previewFileData.numPages}" @click="changePdfPage(1)">{{ $t('SeaExport.Next') }}</span>
        </p>
        <pdf
          :src="previewFileData.pdfSrc"
          :page="previewFileData.currentPage"
          @num-pages="previewFileData.numPages=$event"
          @page-loaded="previewFileData.currentPage=$event"
          @loaded="loadPdfHandler"
        />
      </div>
    </cargo-dialog>
  </div>
</template>

<script>

import { cacheName, cache } from '@/utils/cacheManager'
import cargoAdvanceSelect from '@/components/Cargo/Common/cargoAdvanceSelect'
import { Job } from '@/class/model/booking/Job'
import cargoCompanySelect from '@/components/Cargo/Common/cargoCompanySelect'
import {
  getInsureList,
  getInsureRecord,
  removeInsureRecord
} from '@/api/external/insureInfo'
import CargoAgGridSelectEditor from '@/components/Cargo/Common/CargoAgGridSelectEditor'
import ColumnUtils from '@/utils/ColumnUtils'
import OperationRender from '@/components/OperationRender'
import * as InsuranceConstants from '@/class/cargo/model/parameters/InsuranceConstants'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import pdf from 'vue-pdf'
import { formatNumberToThousands } from '@/utils'
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { findByFileId } from '@/api/storage'
import URL from '@/api/urlTranslator'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'

export default {
  name: 'TabInsure',
  components: { CargoDialog, pdf, cargoAdvanceSelect, cargoCompanySelect, CargoAgGridSelectEditor },
  props: {
    context: {
      type: Object,
      required: true
    },
    action: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      gridParams: {},
      left: {
        gridParams: {},
        gridOptions: {
          rowSelection: 'single',
          suppressCellSelection: true,
          pagination: false,
          onRowClicked: (event) => {
            this.onLeftRowClicked(event.data)
          }
        },
        rowData: [],
        gridApi: null
      },
      right: {
        gridOptions: {
          rowSelection: 'multiple',
          suppressCellSelection: true,
          suppressRowClickSelection: false
        },
        rowData: [],
        gridApi: null
      },
      leftColumnDefs: [
        {
          headerName: this.$t('SeaExport.BlNo'),
          field: 'billno',
          width: 200,
          cellRenderer: (params) => {
            if (params.value === '') {
              return this.$t('CargoMsg.Cargo_All')
            }
            return params.value
          }
        }
      ],
      job: new Job().fillDefaultValue().getData(),
      curBill: null, // 当前选择的提单数据
      storageURL: '',
      // 预览文件参数
      previewFileData: {
        visible: false,
        pdfUrl: '',
        pdfSrc: '',
        numPages: 0,
        currentPage: 0
      },
      isHM: false
    }
  },
  computed: {
    isEdit() {
      return this.action !== 'look' || !(this.curBill && this.curBill.billno)
    },
    rightColumnDefs() {
      const rightColumnDefs = [
        {
          headerName: '', width: 60, checkboxSelection: true,
          sortable: false, suppressMenu: true, suppressSizeToFit: true, resizable: false,
          headerCheckboxSelection: true
        },
        { headerName: this.$t('Insurance.TheInsured'), field: 'insuredName', colId: 'insuredName' },
        { headerName: this.$t('Insurance.InsuranceAgent'), field: 'insuranceAgent', colId: 'insuranceAgent',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.INSURANCE_AGENT)
          }
        },
        { headerName: this.$t('Insurance.InsuranceCompany'), field: 'insuranceCompany', colId: 'insuranceCompany',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.INSURANCE_COMPANY)
          }
        },
        { headerName: this.$t('Insurance.InsureNo'), field: 'insureNo', colId: 'insureNo' },
        { headerName: this.$t('Insurance.PolicyNo'), field: 'policyNo', colId: 'policyNo' },
        { headerName: this.$t('SeaExport.BusinessNo'), field: 'jobNo', colId: 'jobNo' },
        { headerName: this.$t('Insurance.BillOfLoadingNo'), field: 'billno', colId: 'billno' },
        { headerName: this.$t('Insurance.PlaceOfOrigin'), field: 'portLoading', colId: 'portLoading', width: 160 },
        { headerName: this.$t('Insurance.Destination'), field: 'destination', colId: 'destination', width: 160 },
        {
          headerName: this.$t('Insurance.InsureOrderUser'),
          field: '',
          colId: '',
          width: 200,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('Insurance.EditViewInsuranceForm'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.editInsuranceForm(params)
                },
                visible: (params) => this.$checkPermission(['role_cargoInsurance_EditPolicies'])
              }, {
                title: this.$t('CargoMsg.Cargo_Delete'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;color: red',
                onClick: (params) => {
                  this.deleteOnePolicy(params)
                },
                visible: (params) => this.$checkPermission(['role_cargoInsurance_DeletePolicies'])
              },
              {
                title: this.$t('CargoMsg.Cargo_ClaimSettlement'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;color: red',
                onClick: (params) => {
                  ColumnUtils.jumpToInsurance(params)
                },
                visible: (params) => ColumnUtils.isClaimVisible(params) && !this.isHM
              }
            ]
          }
        },
        {
          headerName: this.$t('Insurance.PolicyUser'),
          field: 'insuranceFileId',
          colId: 'insuranceFileId',
          width: 200,
          cellStyle: { textAlign: 'center' },
          cellRendererFramework: OperationRender,
          cellRendererParams: {
            operations: [
              {
                title: this.$t('CargoMsg.Cargo_Preview'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.viewPolicy(params.insuranceFileId)
                },
                visible: (params) => params.insuranceFileId && !this.isHM
              }, {
                title: this.$t('Insurance.PolicyDownload'),
                type: 'primary',
                cssStyle: 'text-decoration: underline;',
                onClick: (params) => {
                  this.downloadFile(params.insuranceFileId)
                },
                visible: (params) => params.insuranceFileId && !this.isHM
              }
            ]
          }
        },
        { headerName: this.$t('Insurance.InvoiceNo'), field: 'invoiceNo', colId: 'invoiceNo' },
        { headerName: this.$t('Insurance.Waybillno'), field: 'waybillno', colId: 'waybillno' },
        { headerName: this.$t('Insurance.Premium'), field: 'premium', colId: 'premium',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        { headerName: this.$t('Insurance.PremiumCurrency'), field: 'premiumCurrency', colId: 'premiumCurrency' },
        { headerName: this.$t('Insurance.Rate'), field: 'rate', colId: 'rate' },
        { headerName: this.$t('Insurance.SubmissionTime'), field: 'submitDate', colId: 'submitDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.DeliveryTime'), field: 'issuingTime', colId: 'issuingTime',
          cellRenderer: (params) => {
            return ColumnUtils.dateTimeLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.DeliveryStatus'), field: 'issuingState', colId: 'issuingState',
          cellRenderer: (params) => {
            return ColumnUtils.showTypeLabelFunc(params.value, InsuranceConstants.ISSUING_STATUS)
          }
        },
        { headerName: this.$t('Insurance.DateOfShipment'), field: 'departureStartDate', colId: 'departureStartDate',
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.InvoiceAmount'), field: 'invoiceAmount', colId: 'invoiceAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        { headerName: this.$t('Insurance.InvoiceCurrency'), field: 'invoiceCurrency', colId: 'invoiceCurrency' },
        { headerName: this.$t('Insurance.InsuranceAmount'), field: 'insuranceAmount', colId: 'insuranceAmount',
          cellRenderer: (params) => {
            return formatNumberToThousands(ColumnUtils.number2ColumnLabelFunc(params.value))
          }
        },
        { headerName: this.$t('Insurance.InsuranceCurrency'), field: 'insuranceCurrency', colId: 'insuranceCurrency' },
        { headerName: this.$t('Insurance.StartDate'), field: 'insuranceDate', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.EndDate'), field: 'finInsuranceDate', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.dateLabelFunc(params.value)
          }
        },
        { headerName: this.$t('Insurance.PolicySyncStatus'), field: 'policySyncStatus', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.offsetStateLabFun(params.value)
          }
        },
        { headerName: this.$t('Insurance.PremiumSyncStatus'), field: 'premiumSyncStatus', width: 140,
          cellRenderer: (params) => {
            return ColumnUtils.offsetStateLabFun(params.value)
          }
        }
      ]
      return rightColumnDefs
    }
  },
  async created() {
    await cache.load(cacheName.USER, cacheName.CONFIG)
    this.storageURL = cache.config.get('StorageURL')
    this.isHM = cache.config.get('ToExoSystem') === 'HONGMING'
    this.user = cache.user
  },
  methods: {
    async onShow(row, isRefresh) {
      if (!isRefresh) {
        return
      }
      this.job = row
      if (row.uuid) {
        // 加载列表数据
        this.loadList()
        this.right.rowData = []
      }
    },
    loadList() {
      getInsureList({ jobUuid: this.job.uuid }).then(res => {
        this.left.rowData = [{ billno: '', billkey: '', insureType: '' }, ...res.data]
      })
      this.curBill = null
      if (this.left && this.left.gridApi) {
        this.left.gridApi.clearFocusedCell()
      }
      this.onLeftRowClicked({ billno: '', billkey: '', insureType: '' })
    },
    onLeftRowClicked(data) {
      this.curBill = data
      const payload = {
        jobUuid: this.job.uuid,
        billno: data.billno,
        insureType: data.insureType
      }
      if (data.insureType === 'DOC') {
        payload.docUuid = data.billkey
      }
      const loading = getLoading4Cxt(this)
      getInsureRecord(payload).then(res => {
        this.right.rowData = res.data
      }).finally(() => {
        if (this.right && this.right.gridApi) {
          this.right.gridApi.clearFocusedCell()
        }
        loading.close()
      })
    },
    async openInsure() {
      const payload = {
        jobUuid: this.job.uuid,
        branchId: this.$store.getters.currentOfficeId,
        docUuid: this.curBill.billkey,
        billno: this.curBill.billno,
        insureType: this.curBill.insureType
      }
      const continueExec = await JobUtils.openInsure(payload, this.view)
      if (continueExec) {
        // 跳转的key 再货运险列表中使用的是记录的UUID,此处没有生成使用billno替代
        this.$router.push({
          name: 'ToInsurePage',
          query: { openNew: true, title: this.$t('Insurance.ToInsure') + payload.billno, key: payload.billno },
          params: { insureForm: payload }
        })
      }
    },
    // 删除单个保单
    async deleteOnePolicy(data) {
      if (!this.$checkPermission(['role_cargoInsurance_DeletePolicies']) && !this.$store.getters.isAdmin) {
        this.$message.warning(this.$t('Insurance.YouPermissionToDeletePolicy'))
        return
      }
      if (data.issuingState === InsuranceConstants.SUBMITTED.code || data.issuingState === InsuranceConstants.ISSUED_ORDER.code) {
        this.$message.warning(this.$t('Insurance.NotAllowDeleteSubmited'))
        return
      }
      await this.$confirm(this.$t('Insurance.DeletingThePolicyRecordContinue'), this.$t('Insurance.Confirm'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        closeOnClickModal: false,
        type: 'warning'
      }).then(() => {
        const insureKeys = []
        insureKeys.push(data.uuid)
        const loading = getLoading4Cxt(this)
        removeInsureRecord({ insureKeys: insureKeys }).then(res => {
          this.$message.success(this.$t('CargoMsg.Cargo_DeletedSuccessfully'))
          this.onLeftRowClicked(this.curBill)
        }).finally(() => loading.close())
      })
    },
    // 编辑/查看保单
    editInsuranceForm(data = null) {
      if (this.isHM) {
        window.open(data.insureLink)
        return
      }
      this.$router.push({
        name: 'ToInsurePage',
        query: { openNew: true, title: this.$t('Insurance.ToInsure') + data.billno, key: data.uuid },
        params: { insureForm: data }
      })
    },
    // 账单查询
    billQuery(data) {
      this.$emit('changeTab', 'bill', data.uuid, data.insuranceAgent)
    },
    // 改变PDF页码,val传过来区分上一页下一页的值,0上一页,1下一页
    changePdfPage(val) {
      // console.log(val)
      if (val === 0 && this.previewFileData.currentPage > 1) {
        this.previewFileData.currentPage--
        console.log(this.previewFileData.currentPage)
      }
      if (val === 1 && this.previewFileData.currentPage < this.previewFileData.numPages) {
        this.previewFileData.currentPage++
        console.log(this.previewFileData.currentPage)
      }
    },
    loadPdfHandler(e) {
      this.previewFileData.currentPage = 1 // 加载的时候先加载第一页
    },
    // 查看保单
    async viewPolicy(value) {
      if (!value) {
        return
      }
      let { numPages } = this
      let pdfSrc = ''
      const res = await findByFileId(value)
      if (res && res.data) {
        const arrayBuffer = new Uint8Array(await res.data.arrayBuffer())
        const loadingTask = pdf.createLoadingTask(arrayBuffer)
        await loadingTask.promise.then(pdf => {
          numPages = pdf.numPages
        })
        pdfSrc = arrayBuffer
      }
      this.previewFileData.pdfSrc = pdfSrc
      this.previewFileData.numPages = numPages
      this.previewFileData.currentPage = 1
      this.previewFileData.visible = true
    },
    // 下载
    downloadFile(value) {
      window.open(`${URL.common.findByFileId}/${value}?sessionId=${this.user.sessionId}`)
    },
    closePreviewDialog() {
      this.previewFileData.pdfSrc = ''
      this.previewFileData.numPages = ''
      this.previewFileData.visible = false
    }
  }
}
</script>

<style>
</style>
